import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-education",
  "use": "icon-education-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-education\">\n  <path d=\"M512 85.333333L85.333333 298.666667l426.666667 213.333333 341.333333-170.666667v298.666667h85.333334V256L512 85.333333z m0 170.666667L232.533333 170.666667 512 85.333333l279.466667 85.333334L512 256z\" fill=\"currentColor\" p-id=\"2427\" />\n  <path d=\"M170.666667 384v298.666667c0 94.293333 153.173333 170.666667 341.333333 170.666666s341.333333-76.373333 341.333333-170.666666V384l-85.333333 42.666667v256c0 23.466667-114.346667 85.333333-256 85.333333s-256-61.866667-256-85.333333V426.666667L170.666667 384z\" fill=\"currentColor\" p-id=\"2428\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/education.svg
// module id = wyC6
// module chunks = 117